import { DialogContent, DialogContentText, Grid } from "@mui/material";
import CustomButton from "../../../../components/common/button/CustomButton";
import Popup from "../../../../components/common/model/Popup";
import closeIcon from "../../../../assets/closeModel.png";
import useStyles from "../../../../components/common/model/styles";
import React, { useEffect, useState } from "react";
import FormField from "../../../../components/common/FormField";
import { feedbackFields } from "./completionAllFields";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getSingleLeadFeedbackAction } from "../../../../store/reducers/feedbackSlice";

interface ManageFeedbackProps {
  open: boolean; // Define the 'open' prop
  onHide: () => void; // Define the 'onHide' prop
  title: string; // Define the 'title' prop
  selectLead?: any; // Adjust type as per your requirement
  action?: any;
}

const ManageFeedback: React.FC<ManageFeedbackProps> = (props) => {
  const classes = useStyles();

  const dispatch = useDispatch();
  const { leadDetails } = useSelector((state: any) => state.lead);
  const {singleLeadFeedback} = useSelector((state: any) => state.feedback);
  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState<
    "sm" | "xs" | "md" | "lg" | "xl" | false
  >("md"); // Adjust the type definition

  const { onHide, open, title } = props;
  const submitHandler = () => {
    props.onHide();
  };
  const closeModel = () => {
    props.onHide();
  };

  const hideHandler = () => {
    props.onHide();
  };

  useEffect(() => {
    if (leadDetails) {
      dispatch(getSingleLeadFeedbackAction(leadDetails?.lead?.generated_id));
    }
  }, [leadDetails]);

  const [formData, setFormData] = useState<any>({});

  // Set form data when feedbacks are available
useEffect(() => {
  if (singleLeadFeedback) {
    const feedbacksData = singleLeadFeedback.reduce((acc: any, feedback: any, index: number) => {
      // Convert numeric question_id (1, 2, etc.) to q1, q2, etc.
      const questionKey = `${feedback.question_id}`; // Prefix 'q' to match the id in feedbackFields
      
      // Check if the category is 'suggestion'
      if (feedback.category === "suggestion") {
        // Set the last questionKey with the suggestion text
        acc[`${feedbackFields.length}`] = feedback.question_text; // Assuming q6 is the last question
      } else {
        // For other questions, set the formData as usual
        acc[questionKey] = feedback.question_text;
      }

      return acc;
    }, {});
    setFormData(feedbacksData);
  }
}, [singleLeadFeedback]);


  return (
    <>
      <Popup
        open={open} // Example value, replace with your actual state or variable
        title={title} // Example title, replace with your actual title
        onHide={hideHandler}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        aria-describedby="alert-dialog-slide-description"
        header={
          <>
            <img
              onClick={hideHandler}
              src={closeIcon}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
        footer={
          <>
            <CustomButton
              style={{ padding: "10px 30px", height: "36px" }}
              variant="outlined"
              title="Cancel"
              onClick={closeModel}
            />
            <CustomButton
              style={{ padding: "10px 30px", height: "36px" }}
              title="Submit"
              onClick={submitHandler}
            />
          </>
        }
      >
        <DialogContent>
          <DialogContentText className={classes.formAddBox}>
            <>
              <Grid container spacing={2}>
                {singleLeadFeedback && singleLeadFeedback?.map((field:any, i:number) => {
                  return (
                    <FormField
                      onPaste={(e: any) => e.preventDefault()}
                      {...{
                        ...field,
                        value: formData ? formData[field.id] || "" : "",
                        ...{
                          variant: "outlined", // Adding this variant prop
                          //   onChange: onChangeAction,
                          //   onBlur: onBlurAction,
                          isNonMarginTop: true,
                          InputProps: {
                            sx:
                              field?.type === "text" ||
                              field?.type === "password"
                                ? { height: "36px" }
                                : { padding: "10px 4px", height: "36px" },
                          },
                        },
                      }}
                    />
                  );
                })}
              </Grid>
            </>
          </DialogContentText>
        </DialogContent>
      </Popup>
    </>
  );
};
export default ManageFeedback;
